<template lang='pug'>
  v-combobox(
    :label='label'
    @input='update'
    :value='value'
    :items='available'
    item-text='name'
    return-object
    hide-no-data
    open-on-clear
    clearable)
    template(v-slot:selection='{attrs, item, index, selected, disabled, parent}')
      v-chip(small v-bind='attrs' :input-value='selected' :disabled='disabled' :key='index')
        v-icon(:size='size' :color='item.color') {{item.icon}}
        span &nbsp;{{item.name}}
    template(v-slot:item='{item}')
      v-chip
        v-icon(:size='size' :color='item.color') {{item.icon}}
        span &nbsp;{{item.name}}
</template>

<script>
import _ from 'lodash';

export default {
  name: 'StatusFilter',
  props: {
    label: {
      default() {
        return 'Filter by Status';
      }
    },
    value: {
      default() {
        return null;
      }
    }
  },
  methods: {
    update(value) {
      this.$emit('input', value);
    }
  },
  watch: {
    // eslint-disable-next-line
    search: _.debounce(function () {
      this.load();
    }, 250)
  },
  data() {
    return {
      size: 24,
      available: [
        {
          name: 'Passing',
          value: 'PASSING',
          color: 'success',
          icon: 'check_circle'
        }, {
          name: 'Failing',
          value: 'FAILING',
          color: 'error',
          icon: 'cancel'
        }, {
          name: 'Other',
          value: 'OTHER',
          color: 'default',
          icon: 'remove_circle_outline'
        }]
    };
  }
};
</script>

<style scoped>

</style>
